import { Focusable, Tooltip } from '@cfa/react-core';

interface PlanCardIconProps {
  icon: React.JSX.Element;
  tooltip?: React.ReactNode;
}

const PlanCardIcon: React.FC<PlanCardIconProps> = ({ icon, tooltip }) =>
  tooltip ? (
    <Tooltip.Root delay={250}>
      <Focusable>{icon}</Focusable>
      <Tooltip.Content placement="top">{tooltip}</Tooltip.Content>
    </Tooltip.Root>
  ) : (
    icon
  );

export default PlanCardIcon;
